const StreamedEvents = require('../StreamedEvents');
const LicenseInfo = require('../LicenseInfo');
const ReportService = require('../ReportService');
const View = require('../../../../../_lib/core/View');

class ReportView extends View {
  constructor(modal, btn) {
    super('report-modal');

    this.modal = modal;
    this.reportedTitles = [];
    this.reportService = new ReportService();

    this.submitAndViewEl = modal.find('button[name=submit-view]');
    this.submitAndStayEl = modal.find('button[name=submit-continue]');
    this.streamedEventsEl = modal.find('[name=streamed_events]');
    this.recordingOptionEl = modal.find('[name=recording_option]');
    this.licenseTypeSelect = modal.find('.select-licenseType');
    this.licenseTypeContainer = modal.find('.license-type');
    this.weeksSelect = modal.find('.time-report');
    this.cancelEl = modal.find('#btnEditCancel');
    this.form = modal.find('form');

    this.currentButton = btn;
    this.buttonData = btn.data();

    this.streamedEvents = new StreamedEvents(this, this.streamedEventsEl);
    this.licenseInfo = new LicenseInfo(this);
  }

  configureElements() {
    this.recordingOptionEl.select2nonUnique({
      placeholder: 'Recording Option',
      minimumResultsForSearch: Infinity
    });
  }

  bindElements() {
    this.bind(this.submitAndViewEl, 'click', async (e) => {
      await this.onSubmitClick(e);
    });

    this.bind(this.submitAndStayEl, 'click', async (e) => {
      await this.onSubmitClick(e);
    });

    this.bind(this.cancelEl, 'click', (e) => {
      this.onCancelClick(e);
    })
  }

  async onSubmitClick(e) {
    const btn = $(e.currentTarget);
    const action = btn.data('action');
    const dataArr = this.getDataFromForm();

    localStorage.setItem('lastSelectedReprint', this.licenseInfo.getLicenseTypeVal());
    localStorage.setItem('lastSelectedWeek', this.licenseInfo.getWeeksVal());

    this.loading();

    await this.reportService.reportTitles(dataArr, this.reportedTitles, action)
      .done((data) => {
        this.onTitlesReported(action, data.link);
      })

    this.loading('reset');
  }

  onTitlesReported(action, link) {
    if (action === 'view' && link) {
      this.redirect(link);
    } else {
      $('.report-checkbox').attr('checked', false);
      this.hideModal();
    }
  }

  onCancelClick(e) {
    this.hideModal();

    e.preventDefault();
  }

  hideModal() {
    this.modal.modal('hide');
  }

  updateHeading(text) {
    this.modal.find('#heading').html(text);
  }

  getDataFromForm(key) {
    return this.getArrayOrKeyValue(this.form.serializeJson(), key);
  }

  getDataFromButton(key) {
    return this.getArrayOrKeyValue(this.buttonData, key);
  }

  getArrayOrKeyValue(array, key) {
    if (typeof key !== 'undefined') {
      return array[key];
    } else {
      return array;
    }
  }

  loading(mode) {
    const btn = this.modal.find('button');
    btn.loading(mode);
  }

  redirect(url) {
    window.location.href = url;
  }
}

module.exports = ReportView;
